var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12 h5"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_c('div',{staticClass:"col-12 h5"},[_vm._v("\n    "+_vm._s(_vm.counter.value)+"\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }